<template>
    <az-dialog v-if="mostrar" @ok="emitirEventoOk" :width="450">
        <wrapper-dialog>
            <div class="dialog-erro">
                <v-card-text class="dialog-title">Cadastro incompleto</v-card-text>
                <span class="dialog-text">
                    Sr.(a) licitante, as informações abaixo não foram preenchidas em seu cadastro.
                    Por favor, entre em contato com o suporte.
                </span>
                <br/>
                <div class="inconsistencies" v-if="inconsistenciasFornecedor.length">
                    <span class="inconsistency-title dialog-text">Fornecedor</span>
                    <div class="inconsistency-list">
                        <ul>
                            <li v-for="inconsistencia in inconsistenciasFornecedor" :key="inconsistencia">
                                <span class="dialog-text">{{inconsistencia}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="inconsistencies" v-if="inconsistenciasRepresentante.length">
                    <span class="inconsistency-title dialog-text">Representante</span>
                    <div class="inconsistency-list">
                        <ul>
                            <li v-for="inconsistencia in inconsistenciasRepresentante" :key="inconsistencia">
                                <span class="dialog-text">{{inconsistencia}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </wrapper-dialog>
    </az-dialog>
</template>

<script>
    import WrapperDialog from '@/commons/components/WrapperDialog'

    export default {
        name: 'LicitacaoFornecedorInconsistenciasFornecedor',
        components: {
            WrapperDialog
        },
        props: {
            inconsistencias: {
                default: {}
            },
            mostrar: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            inconsistenciasFornecedor() {
                return this.inconsistencias.inconsistenciasFornecedor
            },
            inconsistenciasRepresentante() {
                return this.inconsistencias.inconsistenciasRepresentante
            }
        },
        methods: {
            emitirEventoOk() {
                this.$emit('ok')
            }
        }
    }
</script>

<style lang="stylus">
    .inconsistencies
        text-align left
        margin-top 10px
        .inconsistency-list
            border 1px solid #ccc
            border-radius 2px
            text-align left
            padding 10px
        .inconsistency-title
            font-weight bold
            margin 10px
</style>
